<template>
  <div>
    <div v-if="isEnabled == 0" class="enableCard">
      <div class="d-flex flex-column enableCardInner">
        <div class="title">{{ $t('gateways.natRecordPassive') }}</div>
        <div class="detail">{{ $t('gateways.enableNatInfo') }}</div>
        <div class="mx-auto">
          <button
            class="btn btn-primary d-block px-12 py-3 rounded"
            ref="enable_button"
            @click="enableService"
          >
            {{ $t('gateways.activate') }}
          </button>
        </div>
      </div>
    </div>

    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
      v-else
    >
    </List>
  </div>
</template>

<script>
// Services
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus'

export default {
  name: 'GatewayNatRecords',
  data() {
    return {
      loading: false,
      header: [
        { text: 'servers.incomingIP', value: 'incoming_ip' },
        { text: 'servers.incomingPort', value: 'incoming_port' },
        { text: 'servers.outgoingIP', value: 'outgoing_ip' },
        { text: 'servers.outgoingPort', value: 'outgoing_port' },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  props: {
    gatewayId: {
      type: String,
      default: '',
    },
    isEnabled: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      if (this.isEnabled == 1) {
        this.loading = true

        const { current_page } = this.meta

        let $query = `iaas/virtual-machines/${
          this.gatewayId
        }/nat-records?position=id|desc&page=${current_page ? current_page : 1}`

        ApiService.get($query)
          .then(({ data }) => {
            this.data = data.data
            this.pagination = data.meta ? data.meta.pagination : {}

            this.loading = false
          })
          .catch((err) => {
            console.log(err)
            this.data = []
            this.loading = false
          })
      }
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    closeDetail() {
      this.showDetail = false
    },
    enableService() {
      this.enableButton = this.$refs['enable_button']
      this.$spinnerLoader.addSpinnerLoader(this.enableButton)

      ApiService.post(`packetbender/netgateways/${this.gatewayId}/nat`)
        .then(({ data }) => {
          EventBus.$emit('reloadGatewayDetail')
        })
        .catch((err) => {
          this.$spinnerLoader.removeSpinnerLoader(this.enableButton)
        })
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
}
</script>
